module.exports = __webpack_public_path__ + "static/img/3053_phase_function_Paper_Points.6beecab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3053_phase_function_Paper_Points.png
// module id = YzJK
// module chunks = 0